import { http } from "api/http";

const getApprovals = ({ queryKey }) => {
  return http.get("/approvals", { params: { ...queryKey[1] } });
};

const updateTaskApprovals = ({ taskId, approvalHierarchyId, removeApproval }: any) => {
  return http.post(`/approval-level/task`, {
    taskId,
    approvalHierarchyId,
    removeApproval
  });
};

const updateInvoiceApprovals = ({ invoiceId, approvalHierarchyId }: any) => {
  return http.post(`/approvals/invoice`, {
    invoiceId,
    approvalHierarchyId,
  });
};

const updateApproval = (data: any) => {
  const { approvalId, status, remarks } = data;
  return http.patch(`/approvals/${approvalId}`, {
    status,
    remarks,
  });
};

export {
  getApprovals,
  updateTaskApprovals,
  updateApproval,
  updateInvoiceApprovals,
};
